import React, { useEffect, useState } from 'react'
import config from '../../../config.json'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import EditBrandsList from './EditBrandsList'
import SaveStateButton from '../../general/SaveStateButton'
import RequestOverlayContainer from '../../overlay/container/RequestOverlayContainer'



const PageElbenwald = ({movies, moviesOrder, metaMovies, brands, goBackPath, programStatus, programError, onUpdateBrandMovieMappings}) => {
    const [mappings, setMappings] = useState(false)


    const onUpdateBrand = moviePk => brand => {
        setMappings(prevState => ({
            ...prevState,
            [moviePk] : brand
        }))
    }

    const onSaveBrands = () => {
        onUpdateBrandMovieMappings(mappings)
    }

    useEffect(() => {
        const values = {}

        Object.keys(movies).map(pk => values[pk] = movies[pk].brand)

        setMappings(Object.assign({}, values))
    }, [movies])


    return (
        <WrapperPageSimple 
            addClassName="edit-all-items edit-all-brands"
            pageTitleTransId={config.routes.elbenwald.transId} 
            overlay={
                <RequestOverlayContainer
                    programStatus={programStatus} 
                    programError={programError}
                />
            } 
            closePagePath={goBackPath}
        >
            <div className="elbenwald-page site-content">
                <div className="selections-item">
                    <div className="selections-item header-accordion-item-open single-section">
                        <div className="selections-item-content accordion-item">
                            <div className="full-sections">
                                <EditBrandsList
                                    movies={movies}
                                    moviesOrder={moviesOrder}
                                    metaMovies={metaMovies}
                                    mappings={mappings}
                                    brands={brands}
                                    onUpdateBrand={onUpdateBrand}
                                />

                                <div className="save-program-button">
                                    <SaveStateButton
                                        status={programStatus}
                                        transId="publish_program_button"
                                        condition={true}
                                        saveState={onSaveBrands}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </WrapperPageSimple>
    )
}

export default PageElbenwald